import useBreakpoints from '@hooks/useBreakpoints';
import useTheme from '@hooks/useTheme';
import { keyframes } from '@emotion/react';
import { Z_INDEX } from '@components/shared/zIndex';

const useStyles = (displayPosition, cursor, isUnlinkedApptNotification) => {
  const {
    font,
    backgroundColor,
    size,
    depth: { boxShadow },
    borderColor,
    animation
  } = useTheme();
  const { isMobile } = useBreakpoints();
  const notificationAlertWidth = isMobile ? 'auto' : '400px';
  const notificationAlertContainer = isMobile
    ? {
        fontSize: font.base.size.xxs,
        left: displayPosition.left,
        right: displayPosition.right,
        bottom: displayPosition.bottom
      }
    : {
        fontSize: font.base.size.m,
        right: displayPosition.right,
        top: displayPosition.top
      };
  const fadeAnimation = keyframes`
    0% { opacity: 1; visibility: visible; }
    100% { opacity: 0; visibility: hidden; }`;

  return {
    notificationAlertContainer: {
      width: notificationAlertWidth,
      backgroundColor: backgroundColor.base,
      position: 'fixed',
      textDecoration: 'none',
      zIndex: Z_INDEX.NOTIFICATION_ALERT_CONTAINER,
      borderRadius: size.border.radius.twoX,
      overflow: 'hidden',
      cursor: isUnlinkedApptNotification ? 'default' : cursor || 'pointer',
      boxShadow: `${boxShadow.soft.xOffset} ${boxShadow.soft.yOffset} ${boxShadow.soft.blurRadius} ${boxShadow.soft.spreadRadius} ${boxShadow.soft.color}`,
      ...notificationAlertContainer
    },
    notificationHeading: {
      paddingLeft: 16,
      paddingRight: isMobile ? 55 : 40,
      fontWeight: font.base.weight.bold,
      marginBottom: 0,
      marginTop: 14
    },
    notificationContent: {
      display: 'flex',
      minHeight: 80
    },
    icon: {
      width: 80,
      height: 80,
      padding: 8
    },
    notificationRightContainer: {
      display: 'flex',
      padding: isMobile ? 8 : '16px 8px',
      fontFamily: font.base.family,
      color: font.color.base,
      lineHeight: font.lineHeight.heading,
      fontWeight: font.base.weight.light
    },
    notificationAlertFooter: {
      marginRight: 40,
      paddingLeft: 16,
      paddingBottom: 16
    },
    linkContentContainer: {
      flex: 1,
      marginRight: 25
    },
    borderTop: {
      width: notificationAlertWidth,
      height: '4px',
      backgroundImage: `linear-gradient(91deg,${borderColor.hover},${borderColor.accent.focus} 102%)`
    },
    notificationAlertHeader: {
      display: 'flex',
      flex: 1,
      paddingRight: 10,
      flexDirection: 'column'
    },
    notificationAlertTextContainer: {
      flex: 1,
      whiteSpace: 'pre-wrap',
      marginRight: 25
    },
    notificationAlertLinkedContent: {
      display: 'block',
      width: '320px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    imageContainerStyle: {
      paddingLeft: '10px',
      backgroundColor: backgroundColor.base,
      border: 'none'
    },
    linkContentInnerContainer: {
      display: 'flex',
      paddingTop: 10
    },
    notificationAlertCancelContainer: {
      position: 'absolute',
      right: 8,
      top: isMobile ? 8 : 16
    },
    notificationAlertCancel: {
      backgroundColor: backgroundColor.base,
      border: 'none',
      alignSelf: 'flex-start',
      color: isMobile ? font.color.brand.base : font.color.base,
      cursor: 'pointer',
      padding: '0px',
      '&:hover': {
        color: isMobile ? font.color.brand.hover : font.color.hover
      }
    },
    notificationAlertSettingsContainer: {
      display: 'flex',
      position: 'absolute',
      right: 4,
      bottom: 12,
      height: 24,
      width: 24
    },
    notificationAlertSettings: {
      backgroundColor: backgroundColor.base,
      border: 'none',
      cursor: 'pointer',
      padding: 0
    },
    notificationAlertWelcome: {
      flex: '1'
    },
    notificationAlertWelcomeTextContainer: {
      paddingBottom: '4px'
    },
    fadeEffect: {
      animation: `${fadeAnimation} ${animation.delay.slowest}ms ease-in .2s forwards`
    },
    notificationAlertLeftImageContainer: {
      width: 80,
      height: 'auto'
    }
  };
};

export default useStyles;
